import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/pip-enter.js
const PipEnterIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M13 2a4 4 0 0 1 4 4v2.645a3.5 3.5 0 0 0-1-.145h-.5V6A2.5 2.5 0 0 0 13 3.5H4A2.5 2.5 0 0 0 1.5 6v6A2.5 2.5 0 0 0 4 14.5h2.5v.5c0 .347.05.683.145 1H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" }),
		/* @__PURE__ */ jsx("rect", {
			width: 10,
			height: 7,
			x: 8,
			y: 10,
			rx: 2
		}),
		/* @__PURE__ */ jsx("path", { d: "M7.25 10A.75.75 0 0 0 8 9.25v-3.5a.75.75 0 0 0-1.5 0V8.5H3.75a.75.75 0 0 0-.743.648L3 9.25c0 .414.336.75.75.75z" }),
		/* @__PURE__ */ jsx("path", { d: "M6.72 9.78a.75.75 0 0 0 1.06-1.06l-3.5-3.5a.75.75 0 0 0-1.06 1.06z" })
	]
});
const ForwardRef = forwardRef(PipEnterIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=pip-enter.js.map